import { useNavigate } from "react-router-dom";

import NoDataModule from "@/components/shared/ui/NoDataModule/NoDataModule";
import { getPressIdFromURL } from "@utils/getStateFromURL";

const ArticleInfoNotDefined = () => {
  const navigate = useNavigate();
  const articleId = getPressIdFromURL();

  return (
    <NoDataModule
      message={`${
        articleId ? `(#${articleId}) ` : ""
      }There is no article information to display. The draft article info may not have been created yet.`}
      buttonLabel="Back to List"
      onButtonClick={() => navigate(-1)}
    />
  );
};

export default ArticleInfoNotDefined;
